<div class="container">
  <router-outlet> </router-outlet>
</div>
<div class="footer">
  <!--   <div><img class="home-icon" src="../../../assets/icons/fogo-e-peixe.png" />comunidade </div> -->
</div>
